<template>
  <section class="deal--create-basic">
    <v-container grid-list-md>
      <v-form v-model="valid" @submit="submitForm">
        <v-layout row wrap>
          <v-flex sm12>
            <div class="deal--create-header">
              <div class="deal--create-header-grid">
                <div>
                  <p class="deal--create-subtitle">Create A New</p>
                  <p class="deal--create-title">Entity</p>
                </div>
                <div class="deal--create--header--span-3">
                  <p class="deal--create-subtitle">Entity Creator</p>
                  <p class="deal--create-title">{{this['user/user'].name}}</p>
                </div>
                <div class="deal--create--header--span-2">
                  <v-btn depressed color="primary" type="submit" :disabled="!valid">Save</v-btn>
                  <v-btn depressed color="primary" disabled>Save And New</v-btn>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex sm12 md12 lg12>
            <v-card class="deal--create-card">
              <p>BASICS</p>
              <div class="deal--create-pd">
                <div class="deal--create-grid-2">
                  <div>
                    <v-text-field label="NAME" :rules="nameRules" v-model="form.name" />
                  </div>
                  <div>
                    <v-autocomplete
                      :items="companies"
                      item-text="name"
                      item-value="id"
                      flat
                      label="OWNER COMPANY"
                      :loading="loading_company"
                      :rules="companyRules"
                      v-model="form.company"
                      :search-input.sync="search_company"
                      clearable
                      persistent-hint
                      allow-overflow
                      @change="companySelected"
                    />
                  </div>
                  <div>
                    <v-autocomplete
                      :items="scrutinizers"
                      item-text="text"
                      item-value="id"
                      flat
                      label="SCRUTINIZER"
                      :loading="loading_scrutinizer"
                      :rules="scrutinizerRules"
                      v-model="form.scrutinizer"
                      :search-input.sync="search_scrutinizer"
                      clearable
                      persistent-hint
                      allow-overflow
                      :disabled="!form.company"
                    />
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { coreClient } from "../../apollo";
import gql from "graphql-tag";

export default {
  data() {
    return {
      scrutinizers: [],
      companies: [],
      form: {
        name: "",
        company: "",
        scrutinizer: ""
      },
      search_company: null,
      loading_company: false,
      search_scrutinizer: null,
      loading_scrutinizer: false,
      companyRules: [v => !!v || "The owner company is required."],
      scrutinizerRules: [v => !!v || "The Scrutinizer is required."],
      nameRules: [
        v => !!v || "The name is required.",
        v => v.length > 2 || "The name must be longer than 2 characters."
      ],
      valid: false
    };
  },
  watch: {
    async search_company(v) {
      if (!v) {
        this.form.company = "";
        await this.getCompanies();
        return;
      }

      this.loading_company = true;
      v && v !== this.form.company && (await this.getCompanies({ name: v }));
      this.loading_company = false;
    },
    async search_user(v) {
      if (!v) {
        this.form.scrutinizer = "";
        await this.getScrutinizers();
        return;
      }

      this.loading_scrutinizer = true;
      v &&
        v !== this.form.scrutinizer &&
        (await this.getScrutinizers({ name: v }));
      this.loading_scrutinizer = false;
    }
  },
  computed: {
    ...mapGetters(["user/user"])
  },
  methods: {
    async companySelected(value) {
      if (value) {
        await this.getScrutinizers();
      }
    },
    async getCompanies(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Companies($name: String, $limit: Int) {
              Companies(name: $name, limit: $limit) {
                docs {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
            }
          `,
          variables: { ...variables, limit: 20 }
        });

        this.companies = data.Companies.docs;
      } catch (e) {
        // Handle this later.
      }
    },
    async getScrutinizers(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Users($name: String, $company: String!, $limit: Int) {
              Users(name: $name, limit: $limit, company: $company) {
                docs {
                  id
                  name
                  email
                }
              }
            }
          `,
          variables: { ...variables, limit: 20, company: this.form.company }
        });

        this.scrutinizers = data.Users.docs.map(doc => {
          doc.text = `${doc.name} (${doc.email})`;
          return doc;
        });
      } catch (e) {
        // Handle this later.
      }
    },
    async createEntity() {
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createEntity(
              $name: String!
              $company: String!
              $scrutinizer: String!
            ) {
              createEntity(
                name: $name
                company: $company
                scrutinizer: $scrutinizer
              ) {
                id
              }
            }
          `,
          variables: this.form
        });

        const { createEntity } = data;

        setTimeout(
          () => this.$router.push("/evoting/entity/" + createEntity.id),
          500
        );
      } catch (e) {
        console.log(e);
        // handle this later.
      }
    },
    async submitForm(e) {
      e.preventDefault();
      await this.createEntity();
    }
  },
  async mounted() {
    await this.getCompanies();
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Entity_create.styl';
</style>
